export default "__VITE_ASSET__z6uxlOAU__"